import { useCallback, useEffect, useState } from 'react';

const getFullscreenElement = () => {
  if (typeof document === 'undefined') {
    return null;
  }

  return document.fullscreenElement || document.webkitFullscreenElement || null;
};

function useFullscreen(targetRef) {
  const [isFullscreen, setIsFullscreen] = useState(
    Boolean(getFullscreenElement())
  );

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(Boolean(getFullscreenElement()));
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange);

    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
      document.removeEventListener(
        'webkitfullscreenchange',
        handleFullscreenChange
      );
    };
  }, []);

  const toggleFullscreen = useCallback(async () => {
    try {
      if (getFullscreenElement()) {
        if (document.exitFullscreen) {
          await document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        }
        return;
      }

      if (targetRef.current?.requestFullscreen) {
        await targetRef.current.requestFullscreen();
      } else if (targetRef.current?.webkitRequestFullscreen) {
        targetRef.current.webkitRequestFullscreen();
      }
    } catch (error) {
      // Ignore fullscreen errors (browser restrictions, unsupported cases).
    }
  }, [targetRef]);

  return { isFullscreen, toggleFullscreen };
}

export default useFullscreen;
